<template>
  <div class="body">
    <div class="change_password">
      <h4 class="change_password_title">{{ $t("password change") }}</h4>
      <form
        @submit.prevent="changePassword"
        class="change-password_form"
        autocomplete="off"
      >
        <div class="change-password_form__content">
          <div class="change-password_form__input-container">
            <input
              autocomplete="off"
              v-model="oldPassword"
              type="password"
              :placeholder="$t('old password')"
              class="change-password_form__input"
              required
            />
          </div>
          <div class="change-password_form__input-container">
            <input
              autocomplete="off"
              v-model="newPassword"
              type="password"
              :placeholder="$t('new password')"
              class="change-password_form__input"
              required
            />
          </div>
          <div class="change-password_form__input-container">
            <input
              autocomplete="off"
              v-model="repeatedNewPassword"
              type="password"
              :placeholder="$t('repeat new password')"
              class="change-password_form__input"
              required
            />
          </div>
          <div v-if="error" class="change-password_form__error">
            {{ errorMessage }}
          </div>
          <div class="change-password_form__submit">
            <button
              type="submit"
              class="change-password_form__button button filled"
            >
              {{ $t("save") }}
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Documents from "@/components/profile/Documents";

export default {
  components: {
    documents: Documents
  },
  data() {
    return {
      uid: this.$store.getters.userId,
      oldPassword: "",
      newPassword: "",
      repeatedNewPassword: "",
      error: false,
      errorMessage: "",
      isLoading: false
    };
  },
  methods: {
    ...mapActions(["userChangePassword"]),
    changePassword() {
      this.isLoading = true;

      this.userChangePassword({
        uid: this.uid,
        oldpass: this.oldPassword,
        newpass: this.newPassword,
        repeatedNewPass: this.repeatedNewPassword
      })
        .then(response => {
          if (response.data.status == 0) {
            this.error = true;
            this.errorMessage = response.data.result.error;
          } else {
            this.error = false;
            this.errorMessage = "";
            this.oldPassword = "";
            this.newPassword = "";
            this.repeatedNewPassword = "";
            alert("Пароль успешно изменён");
          }
        })
        .catch(response => {
          this.error = true;
          this.errorMessage = response.error;
        });
    }
  }
};
</script>

<style scoped>
.change_password_title {
  text-align: center;
}

.body {
  padding: 35px 30px 0;
  display: flex;
}

.change-password_form {
  width: 360px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.change-password_form__heading {
  font-weight: normal;
  font-size: 36px;
}

.change-password_form__content {
  margin-top: 33px;
  display: flex;
  flex-direction: column;
}

.change-password_form__input-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.change-password_form__input-container:not(:last-child) {
  margin-bottom: 15px;
}

.change-password_form__label {
  font-size: 15px;
}

.change-password_form__input {
  width: 100%;
  padding: 10px;
  font-size: 15px;
  outline: none;
  background-color: #e8f0fe;
  border: 1px solid #fff;
  border-radius: 5px;
  box-sizing: border-box;
}

.change-password_form__submit {
  margin-top: 20px;
  width: 100%;
  align-self: flex-end;
  display: flex;
  align-items: center;
}

.change-password_form__button {
  padding: 15px 30px;
  width: 100%;
}

.change-password_form__error {
  margin: 10px;
  background-color: #f9e7e7;
  color: #ef4748;
  text-align: center;
  padding: 10px;
  border: 1px solid red;
}

.documents {
  margin-top: 20px;
}
</style>
